<template>
  <div id="app">
    <app-nav></app-nav>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import Footer from "./components/Footer";
export default {
  name: "App",
  components: {
    appNav: Nav,
    appFooter: Footer
  },
  watch: {
    "$route.name"(to, from) {
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style>
html {
  box-sizing: border-box;
}
*,
*::before,
*::after {
  box-sizing: inherit;
}
* {
  margin: 0;
  padding: 0;
}
body {
  background-color: #f3f3f3;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
}
a {
  color: #000;
  text-decoration: none;
}
h1 {
  color: #000;
  font-size: 28px;
  font-weight: 300;
  margin: 30px 0;
  text-transform: uppercase;
}
.link {
  color: #fdd55b;
  font-weight: 700;
  text-decoration: underline;
}
.link:hover {
  opacity: 0.9;
}
@media screen and (max-width: 800px){
  html {
    font-size: 13px;
  }
  h1 {
    font-size: 22px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue